export const modulePath = {
  ABOUT:"about",
  SERVICE:"service",
  PORTFOLIO:"portfolio",
  CONTACT:"contact",
  CERTIFICATES:"achievements"
};
